import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import * as searchActions from '../rfr-ord-search/rfr-ord-search.actions';
import * as actions from './shared-filters.actions';
import { Store } from '@ngrx/store';
import sharedFiltersReducer from './shared-filters.reducer';


@Injectable()
export class SharedFilterEffects {
    private readonly actions$ = inject(Actions);
    private appStore = inject(Store);


    afterSet$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.set),
        mergeMap(action => [
            searchActions.load({
                query: {
                    filterGroups: action.filterGroups,
                },
            }),
        ]))
    );

    afterUpdate$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.update),
        withLatestFrom(this.appStore.select(sharedFiltersReducer.selectFilterGroups)),
        mergeMap(([_action, filterGroups]) => [
            searchActions.load({
                query: {
                    filterGroups: filterGroups,
                }
            }),
        ]))
    );

    afterReset$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.reset),
        mergeMap(_action => [
            searchActions.load({
                query: {
                    filterGroups: [],
                }
            }),
        ]))
    );

    afterUnset$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.unset),
        withLatestFrom(this.appStore.select(sharedFiltersReducer.selectFilterGroups)),
        mergeMap(([_action, filterGroups]) => [
            searchActions.load({
                query: {
                    filterGroups: filterGroups,
                }
            }),
        ]))
    );
}
